<div [hidden]="!active" class="dc-progress__content">
  <ng-content></ng-content>
</div>
